module.exports = __webpack_public_path__ + "img/Holi 3.1fd7c958.jpeg";